/** isLabelAccessible determines if a label element is a string and can be passed to the accessibilityLabel property on mobile */
export const isLabelAccessible = (label?: any): label is string => typeof label === 'string'
